import { createApi } from "@reduxjs/toolkit/query/react";
import googleReservationAxiosQuery from "../../utils/axios/googleEmail.axios";
import { IEmailReservations } from "../../interfaces/reservations/IEmailReservations";

export const googleReservationsAPI = createApi({
  reducerPath: "googleReservations",
  baseQuery: googleReservationAxiosQuery(),
  tagTypes: ["googleReservations"],
  endpoints: (builder) => ({
    getAllDraftsEmail: builder.mutation<IEmailReservations, string>({
      query: (accessToken: string) => ({
        url: `/agent-reservations/get-summay-emails?accessToken=${accessToken}`,
        method: "POST",
      }),
    }),

    getAllReservationsEmail: builder.mutation<IEmailReservations, string>({
      query: (accessToken: string) => ({
        url: `/agent-reservations/reservation-email?accessToken=${accessToken}`,
        method: "GET",
      }),
    }),
    getOutlookCredentials: builder.query<
      { accessToken: string; refreshToken: string },
      void
    >({
      query: () => ({
        url: `/outlook/credentials`,
        method: "GET",
      }),
    }),
    //
  }),
});

export const {
  useGetAllDraftsEmailMutation,
  useGetAllReservationsEmailMutation,
  useGetOutlookCredentialsQuery,
} = googleReservationsAPI;
